function MerchHeader({
	title,
	subtitle,
}: {
	title: string;
	subtitle?: string;
}) {
	return (
		<div
			className="relative min-h-[calc(100vh)] overflow-hidden"
			style={{
				backgroundImage: "url(/images/header-background.png)",
				backgroundSize: "cover",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
			}}
		>
			<div className="bg-opacity-70 flex h-screen flex-col items-center justify-center gap-6 px-6 text-center">
				<p className="web-heading-h1 z-3 text-white max-sm:p-4">{title}</p>
				{subtitle && <p className="web-body-b1 text-white-80">{subtitle}</p>}
			</div>
		</div>
	);
}

export default MerchHeader;
